import { Gift, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#232F3E] text-white py-12" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-[#FF9900] flex items-center justify-center">
                <Gift className="w-6 h-6 text-black" />
              </div>
              <span className="text-xl font-bold amazon-text">
                BVG<span className="text-[#FF9900]">LINK</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm">
              Fason pi fasil pou achte kat kado Amazon nan Ayiti ak Moncash.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Lyen Rapid</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="/?meru=true" className="hover:text-[#FF9900] transition-colors">Rechaj Meru</a>
              </li>
              <li>
                <a href="/linkamazon" className="hover:text-[#FF9900] transition-colors">Login</a>
              </li>
              <li>
                <a href="/admin" className="hover:text-[#FF9900] transition-colors">Admin</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Kontakte Nou</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#FF9900]" />
                <span>+509 3857-4639</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#FF9900]" />
                <span>bvgpromo@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} BVG LINK. Tout dwa rezève.</p>
        </div>
      </div>
    </footer>
  );
};
